<template>
    <base-custom-settings :form-data="formData" save-message="De wachtstap is aangepast">
        <template #description>
            <text-heading sub>
                Hoeveel tijd vind je ideaal voordat we verder gaan?
            </text-heading>
            <text-description :color="'white'">
                Het is cruciaal om de perfecte balans in timing te vinden voor elke klantreis - niet te vroeg, maar
                zeker ook niet te laat. We willen precies op het juiste moment in de inbox van je klant of lead
                verschijnen. Ons team van experts heeft alle wachttijden in je flow al voor je geoptimaliseerd op basis
                van bewezen best practices. Dit betekent dat de huidige instellingen al een solide basis vormen.
                Echter, jij kent je klanten als geen ander, dus mocht je de voorkeur geven aan een persoonlijkere
                benadering van de wachttijden, dan bieden we je hier de mogelijkheid om deze in te zien en aan te
                passen naar jouw wensen.
            </text-description>
        </template>

        <template #form>
            <flex-container>
                <flex-container align-items="center">
                    <text-heading sub>
                        Welke wachtvoorwaarde wil je?
                    </text-heading>
                    <span v-if="false" v-tooltip.info="'Lorem ipsum'">
                        <svg-icon
                            :icon="IconCircleInfo"
                            :size="IconSize.sm"
                            is-custom-icon
                        />
                    </span>
                </flex-container>
                <flex-container
                    no-wrap
                    justify-content="space-between"
                >
                    <flex-container size="auto">
                        <label>
                            <input
                                v-model="waitCondition"
                                type="radio"
                                value="countdown"
                            />
                            <text-decorator size="xs">Wacht bepaalde tijd</text-decorator>
                        </label>
                    </flex-container>
                    <flex-container size="auto">
                        <label>
                            <input
                                v-model="waitCondition"
                                type="radio"
                                value="dayOfWeek"
                            />
                            <text-decorator size="xs">Wacht tot bepaalde dag van de week</text-decorator>
                        </label>
                    </flex-container>
                </flex-container>

                <flex-container no-wrap align-items="center">
                    <flex-container :size="2">
                        Aantal
                    </flex-container>
                    <flex-container :size="2">
                        <input-group v-model="formData.intervalQuantity">
                            <template #input>
                                <text-input />
                            </template>
                        </input-group>
                    </flex-container>
                    <flex-container :size="8">
                        <input-group :model-value="formData.intervalUnit" @update:model-value="formData.intervalUnit = $event.value">
                            <template #input>
                                <select-input :items="availableUnits">
                                    <template #active="{ bindings }">
                                        {{ availableUnits.find((item) => item.value === bindings.value)?.label }}
                                    </template>
                                </select-input>
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>
            </flex-container>
        </template>
    </base-custom-settings>
</template>

<script setup lang="ts">
    import {
        FlexContainer,
        IconSize,
        InputGroup,
        SelectInput,
        SvgIcon,
        TextDescription,
        TextHeading,
        TextInput,
    } from '@keyvue/one-ui';

    import type { Node, Trigger } from '@keyvue/one-api-client';
    import { computed, reactive, ref } from 'vue';
    import BaseCustomSettings from '@/flow/flow/components/graph/custom-types/CustomSettings.vue';
    import IconCircleInfo from '@keyvue/one-awesome-icons/icons/regular/circle-info.svg?component';

    interface NodeOptions {
        intervalQuantity: number
        intervalUnit: string
    }

    interface Props {
        node: Trigger | Node
    }

    const props = defineProps<Props>();
    const formData = reactive({
        intervalQuantity: props.node.options?.intervalQuantity ?? 1,
        intervalUnit: props.node.options?.intervalUnit ?? 'days',
    } as NodeOptions);

    const availableUnits = computed(() => {
        return [
            { label: 'Minuten', value: 'minutes' },
            { label: 'Uren', value: 'hours' },
            { label: 'Dagen', value: 'days' },
            { label: 'Weken', value: 'weeks' },
            { label: 'Maanden', value: 'months' },
            { label: 'Jaren', value: 'years' },
        ];
    });

    const waitCondition = ref('countdown');
</script>

<style scoped lang="scss">
input[type="radio"] {
    appearance: revert;
    height: unset;
    width: unset;
}
</style>
